import React from "react";
import { Navigate, useLocation } from "react-router-dom";

// --------- TOKEN ----------
export const setToken = (token) => {
  localStorage.setItem("Token", token);
};

export const fetchToken = () => {
  return localStorage.getItem("Token");
};

// --------- ROLE E SECRETARIA ----------
export const setUserRole = (role) => {
  localStorage.setItem("UserRole", role);
};

export const getUserRole = () => {
  return localStorage.getItem("UserRole") || "";
};

export const setUserSecretariaId = (id) => {
  localStorage.setItem("UserSecretariaId", id.toString());
};

export const getUserSecretariaId = () => {
  const id = localStorage.getItem("UserSecretariaId");
  return id !== null ? parseInt(id, 10) : null;
};

export const setUserId = (id) => {
  localStorage.setItem("UserId", id.toString());
};

export const getUserId = () => {
  const id = localStorage.getItem("UserId");
  return id !== null ? parseInt(id, 10) : null;
};

// --------- CHECA ADMIN ---------
export const isAdmin = () => {
  return getUserRole() === "admin";
};

// --------- VERIFICA ACESSO POR ID_SECRETARIA ---------
export const hasAccessToSecretariaId = (idSecretariaProjeto) => {
  if (isAdmin()) return true;
  return getUserSecretariaId() === Number(idSecretariaProjeto);
};
// ----- nomes----//
export const getUserName = () => {
  return localStorage.getItem("UserName") || "";
};
export const setUserName = (name) => {
   localStorage.setItem("UserName", name);
};
// --------- PROTEÇÃO DE ROTAS ---------
export function RequireToken({ children }) {
  const auth = fetchToken();
  const location = useLocation();

  if (!auth) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}
